// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jpb2","content":"styles_content__2dcGm"};